// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  encryptionKey: 'TERA-APP-KEY',
  showErrors: true,
  appVersion: require('../../package.json').version + '-dev',
  environmentName: 'dev',

  GATEWAY_API: 'https://dev.gw.tera-app.com/',
  RESOURCES_API: 'https://dev.api.tera-app.com/',
 //GATEWAY_API : 'https://localhost:44365/',
  //RESOURCES_API : 'https://localhost:44365/',

  ACEP: 'https://dev.acepenergie.com/',
  SICA: 'https://dev.sica-app.com/',
  SICA_RESOURCES_API: 'https://dev.ressources.sica-app.com/',
  IDENTITY_URL: 'https://dev.identity.sica-app.com/',
  EXTERNAL_GOOGLE_AUTH_URL: 'api/auth/external/google?returnUrl=https://dev.tera-app.com/verification',
  EXTERNAL_MICROSOFT_AUTH_URL: 'api/auth/external/microsoft?returnUrl=https://dev.tera-app.com/verification',
  SIREN_SIRET_API_KEY: '39e6b57d-3d26-43d3-a6b5-7d3d2673d372',
};

